var map = {
	"./logo1.jpg": 9653,
	"./logo10.jpg": 3739,
	"./logo11.jpg": 6947,
	"./logo12.jpg": 4236,
	"./logo13.jpg": 7645,
	"./logo14.jpg": 5688,
	"./logo15.jpg": 7299,
	"./logo2.jpg": 911,
	"./logo3.jpg": 5845,
	"./logo4.jpg": 3719,
	"./logo5.jpg": 3112,
	"./logo6.jpg": 6673,
	"./logo7.jpg": 7889,
	"./logo8.jpg": 787,
	"./logo9.jpg": 833
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6429;